import { Modal } from "react-bootstrap"
import { useMutation } from "react-query"
import { toast } from "react-toastify"

import { updateCourseSchedule } from "../../../../../../models/courses/courses"
import CourseScheduleForm from "./CourseScheduleForm"


const EditScheduleModal = ({ queryClient, scheduleQueryKey, courseId, schedule, show, onHide }) => {
    const { mutate, isLoading } = useMutation(data => updateCourseSchedule(courseId, schedule.id, data), {
        onSuccess: () => {
            toast.success('Success')
            queryClient.invalidateQueries([scheduleQueryKey])
            onHide()
        },
        onError: error => toast.error(error?.response?.data?.message)
    })

    return (
        <Modal show={show} onHide={onHide} backdrop="static" keyboard={false} centered>
            <Modal.Header closeButton>
                <Modal.Title>Edit Schedule</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <CourseScheduleForm queryClient={queryClient} data={schedule} onSubmit={data => mutate(data)} submitLoading={isLoading} />
            </Modal.Body>
        </Modal>
    )
}

export default EditScheduleModal